import { useMemo } from 'react';
import { api } from '@/redux/api';
import { Statistic } from '@/types/statistic';

export const useStatistics = (organisationId: number) => {
  const result = api.useGetStatisticsQuery({
    organisationId: organisationId,
  });

  const data = useMemo<Statistic[]>(() => result.data ?? [], [result.data]);

  return { ...result, data };
};
